import { Language } from 'src/lib/utils'

export const getFlatpickrLocale = (lng: string = Language.EN): any => {
  if (lng === Language.EN) {
    return require('flatpickr/dist/l10n/default.js').default['english']
  }

  return require(`flatpickr/dist/l10n/${lng}.js`).default[lng]
}
